import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class PartnerOnboardingService {

  // Base URL picked from webpack-defined env (see config/webpack.*.js)
  private apiUrl = `${process.env.SERVER}/api/manager`;

  constructor(private http: HttpClient) { }

  getPartnerDetails(offset: number = 0, limit: number = 10, mobile?: string, status?: string): Observable<any> {
    const consumer = localStorage.getItem('userId') || '';
    const headers = new HttpHeaders({
      'x-consumer-username': consumer,
      'Content-Type': 'application/json',
      'source': 'supply-dashboard'
    });

    const searchConditions: any = {};
    if (mobile && mobile.trim()) {
      const digits = mobile.replace(/\D/g, '');
      if (digits.length === 10) {
        searchConditions.mobile = digits;
      }
    }
    if (status && status.trim()) {
      searchConditions.status = status.trim();
    }

    const body: any = {
      data: {
        limit: limit,
        offset: offset,
        searchConditions: searchConditions,
        requiredFields: [
          'firstName',
          'lastName',
          'mobile',
          'userId',
          'status',
          'aadhaarNumber',
          'aadhaarStatus'
        ]
      }
    };
    // Use GET with a JSON body (BFF supports GET bodies). Browsers may drop GET bodies when calling upstream,
    // so our BFF forwards this body to the upstream service reliably.
    // Send both body and params for robustness; BFF will read body, and if any intermediary drops it, it can read params
    let params = new HttpParams().set('limit', String(limit)).set('offset', String(offset));
    if (searchConditions.mobile) params = params.set('mobile', searchConditions.mobile);
    if (searchConditions.status) params = params.set('status', searchConditions.status);

    return this.http.request('GET', `${this.apiUrl}/getDetail`, {
      headers: headers,
      body: body,
      params
    }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any) {
    let errorMessage = 'An error occurred';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = error.error.message;
    } else {
      // Server-side error
      errorMessage = (error && error.error && error.error.message)
        ? error.error.message
        : `Error Code: ${error && error.status ? error.status : 'NA'}\nMessage: ${error && error.message ? error.message : 'Unknown error'}`;
    }
    console.error('PartnerOnboardingService Error:', errorMessage);
    return throwError(errorMessage);
  }

  // Update partner manager status or fields via BFF
  updatePartner(body: { userId: string; status?: string;[key: string]: any }): Observable<any> {
    const consumer = localStorage.getItem('userId') || '';
    const headers = new HttpHeaders({
      'x-consumer-username': consumer,
      'Content-Type': 'application/json',
      'source': 'supply-dashboard'
    });
    return this.http.put(`${this.apiUrl}/update`, body, { headers }).pipe(
      catchError(this.handleError)
    );
  }
}
